import { Controller } from "@hotwired/stimulus"

// Href marker for links that should open the online reception instead of
// navigating. Editors can set it in the Lexxy link tool (see
// lexxy/anchor_link_extension.js); only the href survives ActionText
// sanitization and the Lexical editor round-trip.
export const RECEPTION_LINK_HREF = "#online-rezeption"

// Connects to data-controller="reception"
// Opens the docmed online reception overlay (reception_embed.js is loaded
// async in the application layout).
export default class extends Controller {
  open(event) {
    event.preventDefault()
    docmedEmbedHelper.open()
  }

  // Delegated on <body>: catches clicks on any reception anchor link,
  // e.g. inside rendered rich text.
  intercept(event) {
    if (event.target.closest(`a[href="${RECEPTION_LINK_HREF}"]`)) {
      event.preventDefault()
      window.docmedEmbedHelper?.open()
    }
  }
}
